export const COUNTRY_CODES = {
  ru: 'RU'
};
